(function () {
  document.querySelectorAll('[data-social-story-lola]').forEach(function (section) {
    initStack(section);
  });

  function initStack(section) {
    var photos = Array.prototype.slice.call(section.querySelectorAll('[data-social-story-lola-photo]'));
    var details = Array.prototype.slice.call(section.querySelectorAll('[data-social-story-lola-detail]'));
    var dots = Array.prototype.slice.call(section.querySelectorAll('[data-social-story-lola-dot]'));
    var prevBtn = section.querySelector('[data-social-story-lola-prev]');
    var nextBtn = section.querySelector('[data-social-story-lola-next]');

    var total = photos.length;
    if (!total) return;

    // "order" always lists photo indexes from front of the deck to
    // back — order[0] is whichever photo is currently on top/active.
    var order = photos.map(function (photo) {
      return parseInt(photo.getAttribute('data-index'), 10);
    });

    var isAnimating = false;
    var LAUNCH_MS = 600;

    function photoByIndex(index) {
      return photos.filter(function (p) {
        return parseInt(p.getAttribute('data-index'), 10) === index;
      })[0];
    }

    function applyDepths() {
      order.forEach(function (photoIndex, depth) {
        var photo = photoByIndex(photoIndex);
        if (photo) photo.setAttribute('data-depth', String(depth));
      });
    }

    function updateActiveDetail() {
      var activeIndex = order[0];
      details.forEach(function (detail) {
        var isActive = parseInt(detail.getAttribute('data-index'), 10) === activeIndex;
        detail.classList.toggle('is-active', isActive);
      });
      dots.forEach(function (dot) {
        var isActive = parseInt(dot.getAttribute('data-index'), 10) === activeIndex;
        dot.classList.toggle('is-active', isActive);
      });
    }

    // Advance: the front card is thrown away (see CSS .is-launching),
    // and — once that finishes — is instantly moved to the back of the
    // deck order (no transition), while every other card had already
    // shuffled one position forward as soon as the click happened.
    function next() {
      if (isAnimating || total < 2) return;
      isAnimating = true;

      var outgoingIndex = order[0];
      var outgoingPhoto = photoByIndex(outgoingIndex);

      // Rest of the deck moves forward immediately — CSS transitions
      // this smoothly since it's just a depth/transform change.
      order.push(order.shift());
      applyDepths();
      updateActiveDetail();

      if (outgoingPhoto) {
        outgoingPhoto.classList.add('is-launching');
      }

      window.setTimeout(function () {
        if (outgoingPhoto) {
          outgoingPhoto.classList.add('is-snapping');
          outgoingPhoto.classList.remove('is-launching');
          // Force reflow so the "no transition" snap actually applies
          // before we remove is-snapping again.
          void outgoingPhoto.offsetWidth;
          outgoingPhoto.classList.remove('is-snapping');
        }
        isAnimating = false;
      }, LAUNCH_MS);
    }

    // Reverse: pull the card from the back of the deck straight to the
    // front (reverse of "next"), so the arrows always rotate consistently
    // regardless of direction.
    function prev() {
      if (isAnimating || total < 2) return;
      isAnimating = true;

      order.unshift(order.pop());
      applyDepths();
      updateActiveDetail();

      window.setTimeout(function () {
        isAnimating = false;
      }, LAUNCH_MS);
    }

    if (nextBtn) nextBtn.addEventListener('click', next);
    if (prevBtn) prevBtn.addEventListener('click', prev);

    // Puntitos (mobile, ver CSS): a diferencia de las flechas, un punto
    // pide una foto ESPECÍFICA, no solo "la siguiente" — así que hay
    // que calcular cuántas posiciones hay que recorrer para que esa
    // foto llegue al frente, y en qué sentido (el que sea más corto).
    // Cada paso reutiliza next()/prev() tal cual (mismo lanzamiento),
    // encadenados con el mismo tiempo (LAUNCH_MS) que ya usa cada uno
    // internamente, para que cada lanzamiento termine antes de que
    // arranque el siguiente.
    function goToIndex(targetIndex) {
      var currentPos = order.indexOf(targetIndex);
      if (currentPos <= 0) return;

      var stepsForward = currentPos;
      var stepsBackward = total - currentPos;
      var useNext = stepsForward <= stepsBackward;
      var steps = useNext ? stepsForward : stepsBackward;

      function step(remaining) {
        if (remaining <= 0) return;
        if (useNext) {
          next();
        } else {
          prev();
        }
        window.setTimeout(function () {
          step(remaining - 1);
        }, LAUNCH_MS);
      }

      step(steps);
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var index = parseInt(dot.getAttribute('data-index'), 10);
        goToIndex(index);
      });
    });

    // Swipe support (mobile): same mouse-drag/touch-swipe unification
    // via Pointer Events used elsewhere in the project. A swipe just
    // triggers the same next()/prev() the arrows already use, so it
    // gets the exact same throw animation and text sync for free.
    var stack = section.querySelector('[data-social-story-lola-stack]');
    if (stack) {
      var isDragging = false;
      var dragStartX = 0;

      stack.addEventListener('pointerdown', function (event) {
        isDragging = true;
        dragStartX = event.clientX;
        stack.setPointerCapture(event.pointerId);
      });

      stack.addEventListener('pointerup', function (event) {
        if (!isDragging) return;
        isDragging = false;

        var delta = event.clientX - dragStartX;
        var threshold = 40;

        if (delta > threshold) {
          prev();
        } else if (delta < -threshold) {
          next();
        }
      });

      stack.addEventListener('pointercancel', function () {
        isDragging = false;
      });
    }
  }
})();
